import _sfc_main$1 from "./code_editor_tag.vue.js";
import { createBlock, openBlock, renderSlot, withCtx } from "vue";
//#region src/components/code_editor/code_editor_opening_tag.vue
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcCodeEditorOpeningTag" }, {
	props: {
		name: {
			type: String,
			required: true
		},
		selfClosing: {
			type: Boolean,
			default: false
		}
	},
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(), createBlock(_sfc_main$1, { name: __props.name }, {
				end: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 8, ["name"]);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=code_editor_opening_tag.vue.js.map